import React, { useState, useEffect } from "react";
import Form from "../components/Form";
import authService from "../services/auth";
import { useLocation } from "react-router-dom";
import { useVerificationTimer } from "../hooks/useVerificationTimer";
import { useToasts } from "../hooks/useToasts";

const EmailVerificationNotice = (props) => {
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const { addToast } = useToasts();
  const { timeLeft, canSend, formatTime, startCooldown } = useVerificationTimer(email);

  useEffect(() => {
    // Try to get email from props, location.state, or localStorage
    if (props.email) {
      setEmail(props.email);
    } else if (location.state && location.state.email) {
      setEmail(location.state.email);
    } else {
      const verifiedEmail = localStorage.getItem("verifiedEmail");
      if (verifiedEmail) {
        setEmail(verifiedEmail);
        localStorage.removeItem("verifiedEmail");
      }
    }
  }, [props.email, location.state]);

  const handleResend = async () => {
    if (!canSend) {
      addToast(`Please wait ${formatTime(timeLeft)} before sending another email`, "error-warning");
      return;
    }

    setLoading(true);
    
    try {
      await authService.resendVerificationEmail(email);
      addToast("Verification email sent!", "success-info");
      startCooldown(180000); // 3 minutes
    } catch (err) {
      const details = err?.response?.data?.details?.[0];
      
      if (err?.response?.status === 429) {
        const timeLeftMsg = err?.response?.data?.timeLeft;
        const minutes = Math.ceil(timeLeftMsg / 60000);
        addToast(`Please wait ${minutes} minutes before sending another verification email`, "error-warning");
        if (timeLeftMsg) startCooldown(timeLeftMsg);
      } else if (details === "Email is already verified") {
        addToast("Email is already verified", "success-info");
      } else if (details === "Email not found") {
        addToast("No account with that email exists", "error-warning");
      } else {
        addToast("Could not send verification email. Try again later", "error-warning");
      }
    }
    setLoading(false);
  };

  return (
    <Form
      title="Email Verification Required"
      onSubmit={(e) => {
        e.preventDefault();
        handleResend();
      }}
      error={null}
      loading={loading}
      submitText={canSend ? "Resend verification email" : `Resend verification email - Wait ${formatTime(timeLeft)}`}
      showCancel={false}
    >
      <p>
        Your account is not active yet. Please verify your email address to
        continue.
      </p>
      <p style={{ marginBottom: "24px" }}>
        Didn't receive the email? You can resend the confirmation below.
      </p>
    </Form>
  );
};

export default EmailVerificationNotice;
